module.exports = __webpack_public_path__ + "img/20180815_152858_220.e315bca6.jpg";